import common from "./common.json";
import sys from "./sys.json";
import users from "./users.json";
import generations from "./generations.json";
import support from "./support.json";

export default {
	...common,
	...sys,
	...users,
	...generations,
	...support,
};
